import React from 'react';
import PropTypes from 'prop-types';
import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Provides two instances of axios for use by the application - a public client (no authentication),
 * and an authenticated version, which attempts to set the bearer token in each request.
 *
 * @returns the provider component.
 */
function MsalWaiter({ children }) {
  const { inProgress } = useMsal();

  return inProgress === InteractionStatus.None ? (
    children
  ) : (
    <CircularProgress />
  );
}

MsalWaiter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MsalWaiter;
